import React from "react";
import ReactDOM from "react-dom";
import App from "./App/index.jsx";
import { TrackProvider } from "./TrackContext";

const MOUNT_NODE = document.getElementById("album-player");

if (MOUNT_NODE) {
  const data = MOUNT_NODE.getAttribute("data-player-data");

  ReactDOM.render(
    <TrackProvider data={JSON.parse(data)}>
      <App />
    </TrackProvider>,
    MOUNT_NODE
  );
}
